import g from '#core/global';
import load from '#core/load';

const group_$ = '.toggle-input-group';
const select_group_$ = '.toggle-input-group--select';
const option_$ = '.toggle-input-option';
const option_input_$ = '.toggle-input-option__input';
const option_label_$ = '.toggle-input-option__label';
const summary_$ = '.toggle-input-group__summary';
const summary_attr = 'data-all-summary';
const summary_delimiter = ', ';
const contains_attr = 'data-contains';

let has_group = false;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('toggle-input-group')) return false;
		
		load.content(() => {
			has_group = assign_elements();
			if (!has_group) return false;
		});
		load.all(() => {
			has_group = assign_elements();
			if (!has_group) return false;
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_group) return true;
	
	document.addEventListener(g.change_e, e => {
		const $group = e.target.closest(group_$);
		if (!$group) return;
		
		// Close select group
		if ($group.matches(select_group_$)) {
			const group_id = $group.getAttribute(contains_attr);
			expandable.toggle({
				id: group_id,
				force: false,
			});
		}
		
		update_summary($group);
	});
	
	return true;
}


function update_summary($group) {
	const $summary = $group.querySelector(summary_$);
	if (!$summary) return false;
	
	const $options = $group.querySelectorAll(option_$);
	
	let summary = [];
	$options.forEach($option => {
		const $option_input = $option.querySelector(option_input_$);
		if (!$option_input || !$option_input.checked) return false;
		
		const $label = $option.querySelector(option_label_$);
		if (!$label) return false;
		
		const label = $label.textContent || '';
		summary.push(label.trim());
	});
	
	summary = summary.filter(x => x).join(summary_delimiter);
	if (!summary.length) {
		summary = $group.getAttribute(summary_attr);
	}
	
	$group.querySelector(summary_$).textContent = summary;
}
